import React from 'react'
import ChangeItem from './ChangeItem'

const ChangeList = ({ changesList }) => {
  return (
    <div className='changesBlock__list'>
        {
            changesList && changesList.length > 0 ?
                changesList.map(item => {
                    // console.log('item', item)
                    return (
                        <ChangeItem 
                            key={item.id}
                            changeField={item}
                        />
                    )
                })
            : ''
        }
    </div>
  )
}

export default ChangeList